import { API } from "../connectBackend";



//admin userId
export const getUsers = (userId, token) => {
    return fetch(`${API}/users/${userId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}




//for user & admin 
export const getUser = (userId, token) => {
    return fetch(`${API}/user/${userId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}




//for admin 
//to get user's last activity
export const getLastActivity = (userId, token) => {
    return fetch(`${API}/user/last-activity/${userId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}




//update user
export const editUser = (userId, token, fname, lname, email) => {
    return fetch(`${API}/user/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            fname,
            lname,
            email
        })
    }).then(response => {
        return response.json();
    }).catch(err => console.log(err))
}




//update password
export const updatePassword = (userId, token, currentPassword, newPassword) => {
    return fetch(`${API}/user/password/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            currentPassword, 
            newPassword
        })
    }).then(response => {
        return response.json();
    }).catch(err => console.log(err))
}




//update last-activity
export const updateLastActivity = (userId, token) => {
    return fetch(`${API}/user/last-activity/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    }).then(response => {
        return response.json();
    }).catch(err => console.log(err))
}




//for admin usage
//delete user
export const removeUserByAdmin = (userId, token, customerId) => {
    return fetch(`${API}/admin/delete-user/${userId}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({customerId}),
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//delete user
export const deleteUser = (userId, token) => {
    return fetch(`${API}/user/${userId}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}



